var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"home"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","align":"center","justify":"start"}},[_c('img',{staticClass:"logo",attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}})])],1),_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js + TypeScript App"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }